document.addEventListener('DOMContentLoaded', function() {
    const menuButtonCustom = document.querySelector('.custom-menu-button');
    const menuTrigger = document.querySelector('.m-hamburger-box');
    const closeButton = document.querySelector('.m-menu-drawer__close');

    menuButtonCustom.addEventListener('click', function() {
        menuTrigger.click();
    });

    closeButton.addEventListener('click', function() {
        menuTrigger.click();
    });
});
